<script setup lang="ts">
import PrivacyPolicyModal from './register/PrivacyPolicyModal.vue'

// The auth forms pull in zod and vee-validate, so they are loaded on first open
// instead of shipping with every page
const AuthModal = defineAsyncComponent(() => import('./AuthModal.vue'))
const ForgotPasswordModal = defineAsyncComponent(
  () => import('./forgot-password/ForgotPasswordModal.vue')
)

const authModalStore = useAuthModalStore()

// Stay mounted after the first open so the dialog can play its close animation
const isAuthModalUsed = ref(false)
const isForgotPasswordModalUsed = ref(false)

watchEffect(() => {
  if (authModalStore.isLoginModalOpen || authModalStore.isRegisterModalOpen) {
    isAuthModalUsed.value = true
  }
  if (authModalStore.isForgotPasswordModalOpen) {
    isForgotPasswordModalUsed.value = true
  }
})
</script>

<template>
  <div>
    <AuthModal v-if="isAuthModalUsed" />
    <ForgotPasswordModal v-if="isForgotPasswordModalUsed" />
    <PrivacyPolicyModal />
  </div>
</template>
